import { useState } from "react";
import { Link } from "react-router-dom";

const qrTypes = [
  { id: "url", icon: "ri-links-line", label: "İnternet Sitesi", desc: "Herhangi bir web sitesi URL'sine yönlendirin", color: "bg-emerald-100 text-emerald-600" },
  { id: "vcard", icon: "ri-contacts-line", label: "vCard", desc: "Dijital kartvizitinizi paylaşın", color: "bg-teal-100 text-teal-600" },
  { id: "pdf", icon: "ri-file-pdf-line", label: "PDF", desc: "PDF dosyanızı görüntületin", color: "bg-cyan-100 text-cyan-600" },
  { id: "wifi", icon: "ri-wifi-line", label: "WiFi", desc: "Ağa otomatik bağlanın", color: "bg-emerald-100 text-emerald-600" },
  { id: "video", icon: "ri-video-line", label: "Video", desc: "Video içeriğinizi paylaşın", color: "bg-teal-100 text-teal-600" },
  { id: "instagram", icon: "ri-instagram-line", label: "Instagram", desc: "Instagram profilinize yönlendirin", color: "bg-cyan-100 text-cyan-600" },
  { id: "whatsapp", icon: "ri-whatsapp-line", label: "WhatsApp", desc: "WhatsApp mesajı başlatın", color: "bg-emerald-100 text-emerald-600" },
  { id: "facebook", icon: "ri-facebook-line", label: "Facebook", desc: "Facebook sayfanızı paylaşın", color: "bg-teal-100 text-teal-600" },
  { id: "mp3", icon: "ri-music-line", label: "MP3", desc: "Ses dosyanızı paylaşın", color: "bg-cyan-100 text-cyan-600" },
  { id: "app", icon: "ri-app-store-line", label: "Uygulama", desc: "App Store veya Play Store'a yönlendirin", color: "bg-emerald-100 text-emerald-600" },
  { id: "coupon", icon: "ri-coupon-line", label: "Kupon", desc: "İndirim kuponu paylaşın", color: "bg-teal-100 text-teal-600" },
  { id: "social", icon: "ri-share-line", label: "Sosyal Medya", desc: "Tüm sosyal kanallarınızı listeleyin", color: "bg-cyan-100 text-cyan-600" },
];

export default function QrTypesSection() {
  const [selected, setSelected] = useState("url");

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-emerald-600 text-sm font-semibold uppercase tracking-widest">QR Türleri</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3">
            İhtiyacınıza Uygun QR Kodları
          </h2>
          <p className="text-gray-500 mt-4 max-w-xl mx-auto">
            12 farklı QR kod türü arasından seçim yapın ve hemen oluşturmaya başlayın.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {qrTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => setSelected(type.id)}
              className={`flex flex-col items-center gap-3 p-4 rounded-2xl border-2 transition-all cursor-pointer group ${
                selected === type.id
                  ? "border-emerald-400 bg-emerald-50"
                  : "border-gray-100 bg-white hover:border-emerald-200 hover:bg-gray-50"
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${type.color} transition-transform group-hover:scale-110`}>
                <i className={`${type.icon} text-xl`}></i>
              </div>
              <span className={`text-xs font-semibold text-center ${selected === type.id ? "text-emerald-700" : "text-gray-700"}`}>
                {type.label}
              </span>
            </button>
          ))}
        </div>

        {/* Selected type detail */}
        {qrTypes.filter((t) => t.id === selected).map((type) => (
          <div key={type.id} className="mt-8 bg-gray-50 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${type.color}`}>
                <i className={`${type.icon} text-2xl`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900">{type.label} QR Kodu</h3>
                <p className="text-sm text-gray-500 mt-0.5">{type.desc}</p>
              </div>
            </div>
            <Link
              to="/generator"
              className="px-6 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold rounded-full transition-all whitespace-nowrap cursor-pointer"
            >
              Hemen Oluştur
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
